/** @returns {Immutable.List<SourceRecord>} */
export function selectSourcesOrderedByName(state) {
  return state.sources.get('sources')
}

/** @returns {boolean} */
export function selectSourceLoading(state) {
  return state.sources.get('loading')
}

/** @returns {boolean} */
export function selectSourceFailedToLoad(state) {
  return state.sources.get('failedToLoad')
}
